export const TipoProducto = {
    gold: 'TN09',
    black: 'TX02'
}
  
export default TipoProducto;